let tempBox = null;

export function getTempBox(styleEl, tagName = 'div', debug = false) {
  if (!tempBox) {
    tempBox = document.createElement(tagName);
    Object.assign(tempBox.style, {
      position: debug ? 'fixed' : 'absolute',
      top: '20px',
      left: '20px',
      backgroundColor: debug ? 'rgba(255, 255, 0, 0.7)' : 'transparent',
      color: 'black',
      overflow: 'hidden',
      zIndex: debug ? '9999' : '-9999',
      pointerEvents: debug ? 'auto' : 'none',
    });
    document.body.appendChild(tempBox);
  }

  if (styleEl) {
    const style = getComputedStyle(styleEl);
    Object.assign(tempBox.style, {
      height: style.height,
      width: style.width,
      padding: style.padding,
      fontSize: style.fontSize,
      fontFamily: style.fontFamily,
      lineHeight: style.lineHeight,
      letterSpacing: style.letterSpacing,
      whiteSpace: style.whiteSpace,
      wordBreak: style.wordBreak,
      textAlign: style.textAlign,
      boxSizing: style.boxSizing
    });
  }

  return tempBox;
}

export function destroyTempBox() {
  if (tempBox && tempBox.parentNode) {
    tempBox.remove();
    tempBox = null;
  }
}
